const topics = [
  {
    title: "Animal Life Cycles",
    slug: "animallifecycle",
    standardNumber: "LS.2.1",
    description: "Understand animal life cycles.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fanimallifecycle2025video.mp4?alt=media&token=a5f4b0b0-5ca0-436f-8d09-0b25bc2cc186",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fanimallifecycle2025song%20.mp3?alt=media&token=666e6c14-f00a-4379-95cc-3047adb2ac18",
    lyrics: ["(Chorus)",
"Born, developing, reproducing.",
"Life cycle of animals.",
"Born, developing, reproducing.",
"Life cycle of animals.",

"(Verse)",
"Now, all animal life cycles are the same in some ways.",
"We’re all born, we develop, we reproduce, then the cycle starts over again.",
"Humans start reproducing from an egg inside a mother's body,",
"For 9 months then they’re born, learning for 3 years as babies.",
"Then we grow into children, taller, smarter, more independent.",
"Around the ages 13 to 18, we’re teenagers, adolescents.",
"After that, we become adults until we are old and grey.",
"Start a family, when we reproduce the life cycle starts over again.",

"(Chorus)",
"Born, developing, reproducing.",
"Life cycle of animals.",
"Born, developing, reproducing.",
"Life cycle of animals.",

"© Smart Board Learning, LLC. All rights reserved.",],
gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Metamorphosis",
    slug: "metamorphosis",
    standardNumber: "LS.2.1",
    description: "Understand animal life cycles.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmetamorphosis2025video.mp4?alt=media&token=089e2f87-60f3-45f8-a0bc-c404fa20a32d",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmetamorphosis2025song.mp3?alt=media&token=66998bf3-9960-4e1d-b273-f8b3dce186a6",
    lyrics: ["(chorus)",
"Metamorphosis is the process",
"An animal takes when it changes shapes.",
"Metamorphosis is the process",
"An animal takes when it changes shapes.",

"(verse)",
"Let’s look at a frog when it’s born,",
"The eggs hatch and the tadpole comes on.",
"The tadpoles live in the pond",
"With a tail, no legs, no arms.",
"Then after a while the legs start to form.",
"The tail starts to shrink till it’s all gone.",
"The eyes bulge out, the lungs finish developing.",
"Now living on land, the frog is here.",

"(chorus)",
"Metamorphosis is the process",
"An animal takes when it changes shapes.",
"Metamorphosis is the process",
"An animal takes when it changes shapes.",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
{
    title: "Ladybugs",
    slug: "ladybugs",
    standardNumber: "LS.2.1",
    description: "Understand animal life cycles.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fladybug2025video.mp4?alt=media&token=c2b6994f-5378-43ca-b54f-e0d4ffecb949",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fladybug2025song.mp3?alt=media&token=1e2134f5-8637-4675-a7fb-fae4f196b6fc",
    lyrics: ["(chorus)",
"Ladybug, ladybug, crawling all around,",
"Changing and growing without a sound,",
"Egg to larva, pupa too,",
"Then out comes a bug that’s red and new!,",
"Ladybug, ladybug, fly so high,",
"Spots on your back and wings in the sky!,",

"(verse)",
"What is this I see?,",
"I see the ladybug’s eggs, yellow and small.,",
"What is this I see?,",
"I see the eggs hatch and the larva starts to crawl.,",
"What is this I see?,",
"I see the larva eat and I see the larva grow.,",
"What is this I see?,",
"The larva finds a leaf for now and that will be its home.,",
"What is this I see?,",
"The larva becomes a pupa. That’s something like a shell.,",
"What is this I see?,",
"A ladybug comes out of the pupa, doing well!,",

"(chorus)",
"Ladybug, ladybug, crawling all around,",
"Changing and growing without a sound,",
"Egg to larva, pupa too,",
"Then out comes a bug that’s red and new!,",
"Ladybug, ladybug, fly so high,",
"Spots on your back and wings in the sky!,",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Life Cycles",
    slug: "lifecycles",
    standardNumber: "LS.2.1",
    description: "Understand animal life cycles.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Flifecycles2025song.mp3?alt=media&token=b0ad1abe-875f-4933-953a-8d4b57f2da06",
    lyrics: ["(chorus)",
"Life cycles, round and round,",
"Stages of life where changes are found.",
"Butterflies and frogs, let’s compare,",
"Their journeys are different, but life is shared!",

"(verse)",
"A butterfly starts with a tiny egg,",
"Out comes a larva on little legs.",
"It eats and grows, then spins a home,",
"A pupa it’s called, where changes are shown.",
"A frog lays eggs in the water’s flow,",
"Out comes a tadpole, swimming below.",
"With gills and a tail, it wiggles and grows,",
"Then legs appear, as the tail goes!",

"(chorus)",
"Life cycles, round and round,",
"Stages of life where changes are found.",
"Butterflies and frogs, let’s compare,",
"Their journeys are different, but life is shared!",

"(verse)",
"Butterflies change in four cool stages,",
"Egg to larva, pupa to adult ages.",
"Frogs have three steps, but that’s okay,",
"Both grow and change in their own way!",
"Life cycles, round and round,",
"Stages of life where changes are found.",
"Butterflies and frogs, let’s compare,",
"Their journeys are different, but life is shared!",

"(verse)",
"Some have more stages, some have less,",
"Each life cycle is nature’s best.",
"From eggs to adults, their stories shine,",
"Life cycles are amazing, every time!",

"© Smart Board Learning, LLC. All rights reserved.",],
gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Offspring",
    slug: "offspring",
    standardNumber: "LS.2.2",
    description: "Understand that organisms differ from or are similar to their parents and other offspring based on characteristics of the organism.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Foffspring2025song.mp3?alt=media&token=cd9d4279-1bec-4d21-9904-e09aa0beb4c6",
    lyrics: ["(chorus)",
"Offspring are alike, but not the same,",
"Different colors, shapes, or names!",
"From parents, they come, with traits to share,",
"But each one is special, beyond compare!",

"(verse)",
"Kittens from a mama cat, fluffy and sweet,",
"Some are orange, some black, a mix that’s neat.",
"Puppies from the same mom can all look new,",
"With spots or stripes, and colors too!",
"Baby birds in a nest, they chirp and sing,",
"Some have feathers with a shiny wing.",
"Plants grow seeds, they sprout and bloom,",
"Each flower’s color can fill the room!",

"(chorus)",
"Offspring are alike, but not the same,",
"Different colors, shapes, or names!",
"From parents, they come, with traits to share,",
"But each one is special, beyond compare!",

"(verse)",
"Parents pass traits, like eyes or hair,",
"But changes happen here and there.",
"Variation makes nature bright,",
"No two are the same, it’s a wonderful sight!",
"So look around and you will see,",
"Offspring are full of variety!",
"From animals to plants, they’re all unique,",
"Nature’s creations are quite the treat!",

"(chorus)",
"Offspring are alike, but not the same,",
"Different colors, shapes, or names!",
"From parents, they come, with traits to share,",
"But each one is special, beyond compare!",

"© Smart Board Learning, LLC. All rights reserved.",],
gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Inherited",
    slug: "inherited",
    standardNumber: "LS.2.2",
    description: "Understand that organisms differ from or are similar to their parents and other offspring based on characteristics of the organism.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Finherited2025video.mp4?alt=media&token=91e47b15-2c11-480d-87d0-ce23342bd813",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Finherited2025song.mp3?alt=media&token=0618f70d-a9ce-4a81-b04c-39e9dcaa6ef6",
    lyrics: ["(Chorus)",
"When animals are born,",
"There are a lot of different features that they will take on.",
"Some are inherited, some are inherited.",
"When plants are born,",
"There are a lot of different features that they will take on.",
"Some are inherited, some are inherited.",

"(Verse)",
"Now, animals can inherit some features from their parents,",
"Like the color of their hair or the color of their eyes.",
"Animals can inherit some features from their parents,",
"Like the complexion of their skin or even their height.",
"Plants too, can inherit from their parents",
"Their color, their size, and shape.",
"When genes are passed down from your parents,",
"Different features you take.",

"(Chorus)",
"When animals are born,",
"There are a lot of different features that they will take on.",
"Some are inherited, some are inherited.",
"When plants are born,",
"There are a lot of different features that they will take on.",
"Some are inherited, some are inherited.",

"(Verse)",
"Now, animals can inherit some features from their parents,",
"Like the color of their hair or the color of their eyes.",
"Animals can inherit some features from their parents,",
"Like the complexion of their skin or even their height.",
"Plants too, can inherit from their parents",
"Their color, their size, and shape.",
"When genes are passed down from your parents,",
"Different features you take.",

"(Chorus)",
"When animals are born,",
"There are a lot of different features that they will take on.",
"Some are inherited, some are inherited.",
"When plants are born,",
"There are a lot of different features that they will take on.",
"Some are inherited, some are inherited.",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
{
    title: "Matter Rock",
    slug: "matterrock",
    standardNumber: "PS.2.1",
    description: "Understand properties of solids and liquids and the changes they undergo.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmatterrock2025video.mp4?alt=media&token=9dcb63a2-cfea-49ca-8cc7-0d30700ecab3",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmatterrock2025song.mp3?alt=media&token=78f1e7a9-8c65-4b5a-8489-430d502eb06c",
    lyrics: [
      "(Chorus)",
"Matter has mass and takes up space.",
"Matter has mass and takes up space.",
"Three states of matter,",
"Solid, liquid, and gas.",
"Three states of matter,",
"Solid, liquid, and gas.",

"(Verse)",
"Solids, they keep their shape.",
"Solids, they keep their shape.",
"Particles are packed tightly in solids, vibrating.",
"Particles are packed tightly in solids, vibrating.",

"Liquids take the shape of its container.",
"Liquids take the shape of its container.",
"Particles are spread out a little, sliding past each other.",
"Particles are spread out a little, sliding past each other.",

"In gases, the shape will change with its container.",
"In gases, the volume will change with its container.",
"Particles are spread out and move very quickly.",
"Particles are spread out and move very quickly.",

"(Chorus)",
"Matter has mass and takes up space.",
"Matter has mass and takes up space.",
"Three states of matter,",
"Solid, liquid, and gas.",
"Three states of matter,",
"Solid, liquid, and gas.",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    gameType: "multipleChoice",
    titleImage: "", // Motion image URL
  },
  {
    title: "3 States of Matter",
    slug: "3statesofmatter",
    standardNumber: "PS.2.1",
    description: "Understand properties of solids and liquids and the changes they undergo.",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2F3statesofmatter2025video.mp4?alt=media&token=a521644b-b4eb-4a56-89e2-2beb95c71ad7",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2F3statesofmatter2025song.mp3?alt=media&token=4ca634b8-d275-41d6-9e49-36d59970db1b",
    lyrics: ["(Chorus)",
"Matter is everything around you.",
"Matter is made of atoms and molecules.",
"3 states: solids, liquids, gases.",
"3 states: solids, liquids, gases.",

"(Verse)",
"Solids, yes, are hard.",
"Liquids are more like water.",
"Gases are like the atmosphere,",
"That surrounds the earth, our air.",
"Solids, yes, are hard.",
"Liquids are more like water.",
"Gases are like the atmosphere,",
"That surrounds the earth, our air.",
"Those are the 3 states of matter,",
"Those are the 3 states of matter.",
"Solids, liquids, gases.",
"Solids, liquids, gases.",

"(Chorus)",
"Matter is everything around you.",
"Matter is made of atoms and molecules.",
"3 states: solids, liquids, gases.",
"3 states: solids, liquids, gases.",

"© Smart Board Learning, LLC. All rights reserved.",],
gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
{
    title: "Heating & Cooling",
    slug: "heatingandcooling",
    standardNumber: "PS.2.1",
    description: "Understand properties of solids and liquids and the changes they undergo.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fheatingandcooling2025song.mp3?alt=media&token=f9370550-3077-42ee-a0a0-a8a01a268baa",
    lyrics: [
     "(chorus)",
"Heat it up, cool it down,",
"Watch the changes all around!",
"Liquids to gas, or solid to ice,",
"Heating and cooling, science is nice!",

"(verse)",
"Add some heat, water turns to steam,",
"It floats in the air like a misty dream.",
"Cool it down, and watch it fall,",
"Rain turns to puddles, that’s not all!",
"Heat melts butter, chocolate too,",
"Cooling makes them hard, it’s what they do!",
"Ice turns to water, then back again,",
"Heating and cooling are science friends!",

"(chorus)",
"Heat it up, cool it down,",
"Watch the changes all around!",
"Liquids to gas, or solid to ice,",
"Heating and cooling, science is nice!",

"(verse)",
"Evaporation makes water disappear,",
"Heating it up sends it out of here!",
"Cooling it down makes it come back,",
"Forming clouds or frost, on nature’s track.",
"So heat it up, and cool it too,",
"Changes in matter are fun to do.",
"Evaporation, melting, freezing, it’s true,",
"Heating and cooling teach me and you!",

"(chorus)",
"Heat it up, cool it down,",
"Watch the changes all around!",
"Liquids to gas, or solid to ice,",
"Heating and cooling, science is nice!",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    gameType: "multipleChoice",
    titleImage: "", // Motion image URL
  },
  {
    title: "Freeze it up",
    slug: "freezitup",
    standardNumber: "PS.2.1",
    description: "Understand properties of solids and liquids and the changes they undergo.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ffreezeitup2025song.mp3?alt=media&token=c3cd57e6-778b-400d-ae8c-bde7465b128c",
    lyrics: [
    "(chorus)",
"Freeze it up, freeze it up with knowledge.",
"Freeze it up, a liquid to solid!",
"When it gets cold, it starts to freeze,",
"Ice and frost, as cold as you please!",

"(verse)",
"Water turns to ice when the temperature is low.",
"Put it in the freezer and watch the ice show.",
"Juice turns to popsicles, solid and sweet,",
"Then you pull out the popsicle and have a cool treat!",
"When freezing happens, the heat goes away,",
"Liquids turn solid in a frosty display.",
"Snowflakes form when the air gets cold,",
"Freezing is a wonder that never gets old!",

"(chorus)",
"Freeze it up, freeze it up with knowledge.",
"Freeze it up, a liquid to solid!",
"When it gets cold, it starts to freeze,",
"Ice and frost, as cold as you please!",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    gameType: "multipleChoice",
    titleImage: "", // Motion image URL
  },
  {
    title: "Heat it up",
    slug: "heatitup",
    standardNumber: "PS.2.1",
    description: "Understand properties of solids and liquids and the changes they undergo.",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fheatitup2025song.mp3?alt=media&token=fe4766c1-a50e-4bf3-9af3-4e816a93eadd",
    lyrics: [
      "(chorus)",
"Heat it up, watch it change,",
"A solid to liquid, isn’t that strange?",
"Melting happens when it gets hot,",
"Heat it up, that’s what we’ve got!",

"(verse)",
"Ice turns to water, it’s easy to see,",
"Add some heat, it melts naturally.",
"Chocolate melts into a gooey flow,",
"Heat it up, and watch it go!",
"Wax from a candle melts in the flame,",
"It’s still the same wax, just a different name.",
"Sometimes the change won’t go back,",
"Like baking cookies for a tasty snack!",

"(chorus)",
"Heat it up, watch it change,",
"A solid to liquid, isn’t that strange?",
"Melting happens when it gets hot,",
"Heat it up, that’s what we’ve got!",

"(verse)",
"When heat is added, solids can fade,",
"Into liquids, the change is made.",
"Sometimes it’s reversible, sometimes it’s not,",
"But heat is the key to the whole big plot!",
"So heat it up, and watch it flow,",
"Melting solids, now you know.",
"Science is cool, it’s fun to see,",
"How heat brings changes to you and me!",

"(chorus)",
"Heat it up, watch it change,",
"A solid to liquid, isn’t that strange?",
"Melting happens when it gets hot,",
"Heat it up, that’s what we’ve got!",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    gameType: "multipleChoice",
    titleImage: "", // Motion image URL
  },
  {
    title: "Volume & Weight",
    slug: "volumeandweight",
    standardNumber: "PS.2.1",
    description: "Understand properties of solids and liquids and the changes they undergo.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fvolumeandweight2025song.mp3?alt=media&token=c6c6bc4f-ba6e-4933-9cd5-8e8c97ba6267",
    lyrics: ["(Chorus)",
"Volume and weight, they’re not the same.",
"Volume and weight, they’re not the same.",
"They both have a role to play in this game!",
"They both have a role to play in this game!",
"Volume is space, weight is what it feels.",
"Volume is space, weight is what it feels.",
"Volume is space, weight is what it feels.",
"Volume is space, weight is what it feels.",

"(Verse 1)",
"Volume is the space an object takes,",
"Like water in a jar or a piece of cake.",
"It’s about how much it can hold inside,",
"Inside the space, the space that it takes.",
"Weight is heavy, or it can be light,",
"It’s what you feel, gravity’s might.",
"A feather is light, a rock is not,",
"Weight is measured, it shows what it’s got!",

"(Chorus)",
"Volume and weight, they’re not the same.",
"Volume and weight, they’re not the same.",
"They both have a role to play in this game!",
"They both have a role to play in this game!",
"Volume is space, weight is what it feels.",
"Volume is space, weight is what it feels.",
"Volume is space, weight is what it feels.",
"Volume is space, weight is what it feels.",

"(Verse 2)",
"Volume is the space an object takes,",
"Like water in a jar or a piece of cake.",
"It’s about how much it can hold inside,",
"Inside the space, the space that it takes.",
"Weight is heavy, or it can be light,",
"It’s what you feel, gravity’s might.",
"A feather is light, a rock is not,",
"Weight is measured, it shows what it’s got!",

"(Chorus)",
"Volume and weight, they’re not the same.",
"Volume and weight, they’re not the same.",
"They both have a role to play in this game!",
"They both have a role to play in this game!",
"Volume is space, weight is what it feels.",
"Volume is space, weight is what it feels.",
"Volume is space, weight is what it feels.",
"Volume is space, weight is what it feels.",

"© Smart Board Learning, LLC. All rights reserved.",],
gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
{
    title: "Sound Vibration",
    slug: "soundvibration",
    standardNumber: "PS.2.2",
    description: "Understand the relationship between sound and vibrating objects.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsoundvibration2025video.mp4?alt=media&token=cb99546b-37d4-4f3f-a966-0ce7a9d81ce3",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsoundvibration2025song.mp3?alt=media&token=db451312-dd9d-4c4c-babe-357802dc1d67",
    lyrics: ["(chorus)",
"If you did not know where sound came from, well now you know.",
"It’s from the vibration, it’s from the vibration.",
"If you did not know where sound came from, well now you know.",
"It’s from the vibration, it’s from the vibration.",

"(verse)",
"When you grab your guitar and pluck on the string,",
"Listen to the sound, it makes you want to sing.",
"Vibration, vibration, vibration, vibration.",
"You can speak very soft or speak very loud.",
"Your vocal cords vibrate producing sound.",
"Vibration, vibration, vibration, vibration.",

"(chorus)",
"If you did not know where sound came from, well now you know.",
"It’s from the vibration, it’s from the vibration.",
"If you did not know where sound came from, well now you know.",
"It’s from the vibration, it’s from the vibration.",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Instruments",
    slug: "instruments",
    standardNumber: "PS.2.2",
    description: "Understand the relationship between sound and vibrating objects.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Finstruments2025video.mp4?alt=media&token=093de551-f834-49ce-8d4c-d57e59444a8e",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Finstruments2025song.mp3?alt=media&token=f1dd67e9-5b49-4fbd-b112-7726a694c558",
    lyrics: ["(Verse)",
"What do we hear making that sound?",
"What do we hear making that sound?",
"It’s the guitar’s vibrating strings,",
"That makes me want to sing.",

"What do we hear making that sound?",
"What do we hear making that sound?",
"It’s the violin’s vibrating strings,",
"That makes me want to sing.",

"What do we hear making that sound?",
"What do we hear making that sound?",
"It’s the flute’s vibrating air,",
"That’s the sound I love to hear.",

"What do we hear making that sound?",
"What do we hear making that sound?",
"It’s the trumpet’s vibrating air,",
"That’s the sound I love to hear.",

"What do we hear making that sound?",
"What do we hear making that sound?",
"It’s the drum’s vibrating head,",
"Making me shake my head.",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Pitch",
    slug: "pitch",
    standardNumber: "PS.2.2",
    description: "Understand the relationship between sound and vibrating objects.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fpitch2025song.mp3?alt=media&token=520ce9da-9964-498c-a67f-868344433638",
    lyrics: ["(chorus)",
"High pitch, low pitch, sounds we hear,",
"High pitch, low pitch, far and near!",
"High pitch, low pitch, give it a try,",
"Pitch is how the sound goes low or high!",
"High pitch, low pitch, sounds we hear,",
"High pitch, low pitch, far and near!",
"High pitch, low pitch, give it a try,",
"Pitch is how the sound goes low or high!",

"(verse)",
"A bird’s sweet chirp is high, so clear,",
"A lion’s roar is low, you hear!",
"The faster it vibrates, the pitch goes high,",
"The slower it vibrates, the pitch drops by!",

"(chorus)",
"High pitch, low pitch, sounds we hear,",
"High pitch, low pitch, far and near!",
"High pitch, low pitch, give it a try,",
"Pitch is how the sound goes low or high!",

"(verse)",
"A small tight string makes a high sound,",
"A loose big drum makes a low one around!",
"Pitch changes with size and tension too,",
"Play with sounds to see what you can do!",

"(chorus)",
"High pitch, low pitch, sounds we hear,",
"High pitch, low pitch, far and near!",
"High pitch, low pitch, give it a try,",
"Pitch is how the sound goes low or high!",

"(bridge)",
"Clap your hands or hum a tune,",
"Explore the pitch in the afternoon!",
"Sounds are fun, they’re everywhere,",
"High or low, they’re in the air!",

"(chorus)",
"High pitch, low pitch, sounds we hear,",
"High pitch, low pitch, far and near!",
"High pitch, low pitch, give it a try,",
"Pitch is how the sound goes low or high!",

"© Smart Board Learning, LLC. All rights reserved.",],
gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "High & Low Pitch",
    slug: "highandlowpitch",
    standardNumber: "PS.2.2",
    description: "Understand the relationship between sound and vibrating objects.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fhighandlowpitch2025song.mp3?alt=media&token=60f9954f-b688-47fc-989a-e374c9432e13",
    lyrics: ["(chorus)",
"Pitch goes high, pitch goes low,",
"It depends on the size, now you know!",
"Big and long make a deep, low sound,",
"Small and short make it high all around!",
"Pitch goes high, pitch goes low,",
"It depends on the size, now you know!",
"Big and long make a deep, low sound,",
"Small and short make it high all around!",

"(verse 1)",
"If a string is short, it’s high and bright,",
"But a long string plays a sound so light.",
"Big drums boom, their pitch is low,",
"Little drums snap with a higher show!",
"Air in a tube can make sounds too,",
"Longer air columns sound deep and true.",
"Shorter tubes make a whistling high,",
"Pitch is the reason, here’s the why!",

"(chorus)",
"Pitch goes high, pitch goes low,",
"It depends on the size, now you know!",
"Big and long make a deep, low sound,",
"Small and short make it high all around!",

"(verse 2)",
"It’s all about size, it’s easy to see,",
"Longer means low, short means key.",
"From strings to drums, to pipes with air,",
"Pitch is a science that’s everywhere!",

"(chorus)",
"Pitch goes high, pitch goes low,",
"It depends on the size, now you know!",
"Big and long make a deep, low sound,",
"Small and short make it high all around!",

"© Smart Board Learning, LLC. All rights reserved.",],
gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Vibrations All Around",
    slug: "vibrationsallaround",
    standardNumber: "PS.2.2",
    description: "Understand the relationship between sound and vibrating objects.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fvibrationsallaround2025song.mp3?alt=media&token=dd1d047b-88df-4092-add0-5e055da7b377",
    lyrics: ["(Chorus)",
"Vibrations here, vibrations there,",
"Sounds are moving through the air!",
"Our bodies make them, our bodies hear,",
"Let’s learn how sound appears so clear!",

"(Verse 1)",
"Our vocal cords vibrate when we speak,",
"Air makes them move, and sound so sweet.",
"Stretch them tight, the pitch goes high,",
"Loosen them up, the pitch drops by!",

"(Chorus)",
"Vibrations here, vibrations there,",
"Sounds are moving through the air!",
"Our bodies make them, our bodies hear,",
"Let’s learn how sound appears so clear!",

"(Verse 2)",
"The ear detects vibrations, vibrations around.",
"The outer ear collects the sound.",
"Through the canal, the eardrum shakes.",
"We hear the sound when the tiny bones vibrate!",
"Vibration in the inner ear is where the magic is done.",
"The nerve sends signals to the brain for fun.",
"The brain understands the sound we hear,",
"It’s vibrations that make it so clear!",

"(Chorus)",
"Vibrations here, vibrations there,",
"Sounds are moving through the air!",
"Our bodies make them, our bodies hear,",
"Let’s learn how sound appears so clear!",

"© Smart Board Learning, LLC. All rights reserved.",],
gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
{
    title: "A Major Source",
    slug: "amajorsource",
    standardNumber: "ESS.2.1",
    description: "Understand patterns of weather and factors that affect weather.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Famajorsource2025video.mp4?alt=media&token=6b333548-f1cb-45f2-84ac-26a6e3b58e9d",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Famajorsource2025song.mp3?alt=media&token=e2e56f2f-4e14-4a91-b4a8-82f454698e5b",
    lyrics: ["(Verse)",
"The sun is a major source of energy for the Earth, for the Earth.",
"The sun is a major source of energy for the Earth, for the Earth.",
"It helps the plants grow, yes,",
"Through photosynthesis.",
"The sun is a major source of energy for the Earth, for the Earth.",
"The sun is a major source of energy for the Earth, for the Earth.",
"The sun is a major source of energy for the Earth, for the Earth.",
"It helps evaporate water, true,",
"For the water cycle.",
"The sun is a major source of energy for the Earth, for the Earth.",
"The sun is a major source of energy for the Earth, for the Earth.",
"The sun is a major source of energy for the Earth, for the Earth.",
"It heats the Earth’s surface of course,",
"A non-exhaustible resource.",
"The sun is a major source of energy for the Earth, for the Earth.",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "From The Sun",
    slug: "fromthesun",
    standardNumber: "ESS.2.1",
    description: "Understand patterns of weather and factors that affect weather.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ffromthesun2025song.mp3?alt=media&token=f88e1f0a-7fcb-49c8-b4c4-761369219c83",
    lyrics: ["(chorus)",
"The energy from the Sun keeps the water moving,",
"The energy from the Sun keeps the water grooving!",
"The energy from the Sun makes the cycle go,",
"The energy from the Sun makes the water flow!",

"(verse)",
"When the Sun heats the water, it turns into gas,",
"It rises in the air—evaporation, so fast!",
"When the vapor cools down, it turns back to the rain,",
"Falling to the Earth to start the cycle again.",

"(verse)",
"The Sun is the power that makes the water rise,",
"It forms clouds in the air, way up in the skies.",
"Then the water comes down as rain, hail, or snow,",
"Back to rivers and oceans, where the cycle flows.",

"(chorus)",
"The energy from the Sun keeps the water moving,",
"The energy from the Sun keeps the water grooving!",
"The energy from the Sun makes the cycle go,",
"The energy from the Sun makes the water flow!",

"© Smart Board Learning, LLC. All rights reserved.",],
gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "The Suns Day Journey",
    slug: "thesunsdayjourney",
    standardNumber: "ESS.2.1",
    description: "Understand patterns of weather and factors that affect weather.",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fthesunsdayjourney2025song.mp3?alt=media&token=7b7236bb-bcf7-4979-b694-aab50b290605",
    lyrics: ["(chorus)",
"The sun, the sun, it lights our day,",
"Rising in the morning, shining all the way.",
"It moves through the sky, then says goodbye,",
"The sun is amazing, way up high!",

"(verse)",
"In the morning, the sun will rise,",
"Peeking out from the eastern skies.",
"It shines so bright, it warms the air,",
"The sun is with us, everywhere!",
"By the afternoon, it’s way up high,",
"Right in the middle of the bright blue sky.",
"As the evening comes, it starts to set,",
"Glowing orange and red, it’s the prettiest yet!",

"(chorus)",
"The sun, the sun, it lights our day,",
"Rising in the morning, shining all the way.",
"It moves through the sky, then says goodbye,",
"The sun is amazing, way up high!",

"(verse)",
"The sun rises east and sets in the west,",
"It lights up our world, it’s simply the best.",
"At different times, it’s in different places,",
"Changing its spots, with warmth it graces!",
"So look at the sky, watch the sun’s show,",
"Where it starts and ends, now you’ll know.",
"It lights our days, it’s bright and fun,",
"Thanks to the sky and our brilliant sun!",

"(chorus)",
"The sun, the sun, it lights our day,",
"Rising in the morning, shining all the way.",
"It moves through the sky, then says goodbye,",
"The sun is amazing, way up high!",

"© Smart Board Learning, LLC. All rights reserved.",],
gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "The Sun Brings Light",
    slug: "thesunbringslight",
    standardNumber: "ESS.2.1",
    description: "Understand patterns of weather and factors that affect weather.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fthesunbringslight2025video.mp4?alt=media&token=9c5bcfa1-80ab-4aef-9fb0-9283b388ea70",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fthesunbringslight2025song.mp3?alt=media&token=03d2d5c9-1da4-4232-9e9e-63e9cbdf3b69",
    lyrics: ["(chorus)",
"The sun brings light, the sun brings heat,",
"It warms the Earth beneath our feet.",
"Some light reflects, some light’s absorbed,",
"It powers the Earth, a life-giving force!",

"(verse)",
"Light travels far from the sun to here,",
"It heats the Earth, the air so clear.",
"The land and water soak it in,",
"Patterns of warmth help life begin!",
"Reflecting light bounces back to space,",
"But the heat we keep is nature’s grace.",
"Plants grow tall, and oceans glow,",
"The sun’s bright energy makes it so!",

"(chorus)",
"The sun brings light, the sun brings heat,",
"It warms the Earth beneath our feet.",
"Some light reflects, some light’s absorbed,",
"It powers the Earth, a life-giving force!",

"(verse)",
"Absorb the light, feel the heat,",
"The sun makes life a perfect feat.",
"Patterns of warmth, day by day,",
"The sun keeps life going in every way!",
"The sun is a star, a shining light,",
"It keeps us warm through day and night.",
"Reflect, absorb, the patterns we see,",
"The sun is the key to life’s harmony!",

"(chorus)",
"The sun brings light, the sun brings heat,",
"It warms the Earth beneath our feet.",
"Some light reflects, some light’s absorbed,",
"It powers the Earth, a life-giving force!",

"© Smart Board Learning, LLC. All rights reserved.",],
gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Weather Patterns",
    slug: "weatherpatterns",
    standardNumber: "ESS.2.1",
    description: "Understand patterns of weather and factors that affect weather.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fweatherpatterns2025song.mp3?alt=media&token=34f3bcb1-2e6c-41af-af4b-4098fdbe04df",
    lyrics: ["(Verse 1)",
"Weather patterns happen every day,",
"From sunny skies to clouds so gray.",
"Temperature changes, hot or cold,",
"A seasonal story nature has told.",
"The sun’s rays warm the Earth, it’s true,",
"But sometimes we need the coolness too.",

"(Chorus)",
"Weather patterns, they come and they go,",
"From rain to snow, and wind that blows.",
"Let’s learn about them, let’s understand,",
"How they impact our lives, throughout the land.",

"(Verse 2)",
"Rain and snow both fall from the sky,",
"Thunder can rumble, and lightning flashes by.",
"The wind can blow strong, or just a breeze,",
"It shapes our weather and moves the seas.",
"From sunny days to stormy nights,",
"Weather affects our world in so many lights.",

"(Chorus)",
"Weather patterns, they come and they go,",
"From rain to snow, and wind that blows.",
"Let’s learn about them, let’s understand,",
"How they impact our lives, throughout the land.",

"© Smart Board Learning, LLC. All rights reserved.",],
gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Seasons",
    slug: "seasons",
    standardNumber: "ESS.2.1",
    description: "Understand patterns of weather and factors that affect weather.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fseasons2025video.mp4?alt=media&token=dd682414-ff8a-4acb-8877-5a488cd7a912",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fseasons2025song.mp3?alt=media&token=04a34ce0-7b3c-4e70-8564-cc5ac75c2bfc",
    lyrics: ["(chorus)",
"There is something we have to get clear now,",
"there are four seasons in every year now.",
"Do you know the reasons for the seasons? Check this,",
"seasons come because of the tilt of the Earth's axis.",

"(verse)",
"We spring ahead in the Spring, then comes the Summer.",
"Watch the leaves change color, we fall back in Autumn.",
"Then comes the Winter, which is the coldest season.",
"The Earth spins on an axis that is tilted, is the reason why this happens.",

"(chorus)",
"There is something we have to get clear now,",
"there are four seasons in every year now.",
"Do you know the reasons for the seasons? Check this,",
"seasons come because of the tilt of the Earth's axis.",

"(bridge)",
"Summer, Winter, Spring, Fall.",
"Summer, Winter, Spring, Fall.",
"Summer, Winter, Spring, Fall.",
"Summer, Winter, Spring, Fall.",

"© Smart Board Learning, LLC. All rights reserved.",],
gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Determine Weather",
    slug: "determineweather",
    standardNumber: "ESS.2.1",
    description: "Understand patterns of weather and factors that affect weather.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fdetermineweather2025video.mp4?alt=media&token=b0dc68f0-f495-4f84-81eb-e9b804dda225",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fdetermineweather2025song.mp3?alt=media&token=24b9d787-ecf5-4951-9b5e-3f9be7efc183",
    lyrics: ["(Verse)",
"To determine the weather in a particular time and place,",
"You should know the temperature, that’s the measure",
"Of the degree of heat of a substance.",

"To determine the weather in a particular time and place,",
"Look for precipitation, rain, sleet, snow, hail,",
"And time period amounts.",

"To determine the weather in a particular time and place,",
"You should know the wind direction,",
"Which way is it blowing? North, South, East, or West.",

"To determine the weather in a particular time and place,",
"You should know the wind speed, the rate of motion of the air",
"In knots or nautical miles.",

"To determine the weather in a particular time and place,",
"You should know a barometer is used to measure",
"The atmospheric pressure.",

"To determine the weather in a particular time and place,",
"You should know that humidity",
"Is the amount of water vapor in the air, yeah, yeah, yeah, yeah.",

"© Smart Board Learning, LLC. All rights reserved.",],
gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Precipitation",
    slug: "precipitation",
    standardNumber: "ESS.2.1",
    description: "Understand patterns of weather and factors that affect weather.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fprecipitation2025video.mp4?alt=media&token=9be4503a-6378-41d1-be11-38eb8195d5c3",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fprecipitation2025song.mp3?alt=media&token=7cc71098-743b-4545-9391-9b67a7d43062",
    lyrics: ["(Chorus)",
"Precipitation is rain, sleet, snow, and hail.",
"Precipitation is rain, sleet, snow, and hail.",
"It’s raining, it’s snowing.",
"It’s raining, it’s snowing.",
"It’s sleeting, it’s hailing.",
"It’s sleeting, it’s hailing.",

"(Verse)",
"Rain is water droplets falling from the sky.",
"Snow is white crystal flakes made of ice.",
"Sleet, small ice pellets that fall from the sky.",
"Hail, large ice pellets that fall from the sky.",

"(Chorus)",
"Precipitation is rain, sleet, snow, and hail.",
"Precipitation is rain, sleet, snow, and hail.",
"It’s raining, it’s snowing.",
"It’s raining, it’s snowing.",
"It’s sleeting, it’s hailing.",
"It’s sleeting, it’s hailing.",

"© Smart Board Learning, LLC. All rights reserved.",
],
gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
];
export default topics;


